import styled from 'styled-components';

import { Button } from "../Buttons/ButtonV2";
import { DismissingCard } from "../DismissingCard";

export const Container = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Container", componentId: "sc-1sg3s7g-0" })(["display:flex;flex-direction:column;border-radius:8px;background-color:", ";"],



(props) => props.theme.colors.secondaryBackground);


export const BadgeContainer = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__BadgeContainer", componentId: "sc-1sg3s7g-1" })(["padding:6px 0;display:flex;flex-direction:row;"]);





export const Wrap = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Wrap", componentId: "sc-1sg3s7g-2" })(["flex:1 1 auto;display:flex;flex-direction:row;cursor:pointer;"]);






export const Text = /*#__PURE__*/styled.p.withConfig({ displayName: "styles__Text", componentId: "sc-1sg3s7g-3" })(["flex:1 1 auto;line-height:24px;margin:0 0 0 10px;color:", ";", ""],



(props) => props.theme.colors.secondary,
({ theme }) => theme.typography.Paragraph);


export const BadgeDismissingCard = /*#__PURE__*/styled(DismissingCard).withConfig({ displayName: "styles__BadgeDismissingCard", componentId: "sc-1sg3s7g-4" })(["background-color:transparent;margin:0;border:none;padding:8px 14px;"]);






export const CircleDismissButton = /*#__PURE__*/styled(Button).withConfig({ displayName: "styles__CircleDismissButton", componentId: "sc-1sg3s7g-5" })(["margin-left:10px;width:24px;height:24px;border:none;border-radius:12px;padding:0;min-width:auto;background-color:transparent;flex:0 0 auto;display:flex;align-items:center;justify-content:center;"]);